import { Text } from "@overmap-ai/blocks"
import { UNTITLED_ISSUE_TITLE } from "@overmap-ai/common"
import type { Issue, Stored } from "@overmap-ai/common"
import { forwardRef, memo } from "react"

import { IssueTypeIcon } from "../../../components/Icons/IssueTypeIcon"
import { IssueIndexLabel } from "../../../components/IndexLabels/IssueIndex"
import {
	MentionListEmpty,
	MentionListItem,
	type MentionListRef,
	MentionListRoot,
	type MentionListRootProps,
} from "../../blocks"

type IssueMentionListProps = MentionListRootProps<Stored<Issue>>

export const IssueMentionList = memo(
	forwardRef<MentionListRef<Stored<Issue>>, IssueMentionListProps>((props, ref) => {
		const { items } = props

		return (
			<MentionListRoot<Stored<Issue>> ref={ref} {...props}>
				{items.map((issue) => (
					<MentionListItem<Stored<Issue>> item={issue} key={issue.uuid}>
						<IssueTypeIcon issueTypeId={issue.issue_type} inline />
						<IssueIndexLabel issueId={issue.uuid} />
						<Text className="truncate" accentColor="base">
							{issue.title || UNTITLED_ISSUE_TITLE}
						</Text>
					</MentionListItem>
				))}
				<MentionListEmpty>No results</MentionListEmpty>
			</MentionListRoot>
		)
	}),
)
IssueMentionList.displayName = "IssueMentionList"
